var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';
import router from '../../router';
const state = {
  reviews: [],
  pagination_review: {},
}
const mutations = {
  update_list_review(state, data){
    state.reviews = data.list_rating    
    state.pagination_reivew = data.pagination
  }
}
const actions = {
  get_reviews({commit}, data){    
    axios.get(url + '/review/list_reviews?id=' + data.id + '&page=' + data.page,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) => {      
      commit('update_list_review', response.data)
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }
    })
  },
  send_rating({commit}, data){
    axios.post(url + '/review/create', data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) => {
      alert('Đánh giá của bạn đã được gửi đi. Moranow sẽ xác nhận đánh giá này. Xin cảm ơn!')
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }else{
        alert('Có lỗi trong quá trình xử lý')
      }
    })
  }
}
const getters = {
  current_page: state => {
    return state.pagination_reivew.current_page
  },
  next_page: state => {
    return state.pagination_reivew.next_page
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vuex_rating_and_review.js